import { AdminSharedModule } from '@myclubrewards/shared';
import { HomeModule } from './../../../home/src/lib/home.module';
import { PromotionsRoutingModule } from './promotions-routing.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PromotionsComponent } from './components/promotions/promotions.component';
import { PromotionPrimaryComponent } from './components/promotion-primary/promotion-primary.component';
import { PromotionDetailsComponent } from './components/promotion-details/promotion-details.component';
import { PromotionDetailComponent } from './components/promotion-detail/promotion-detail.component';

@NgModule({
  imports: [
    CommonModule,
    PromotionsRoutingModule,
    HomeModule,
    AdminSharedModule,
  ],
  declarations: [PromotionsComponent, PromotionPrimaryComponent, PromotionDetailsComponent, PromotionDetailComponent],
  exports: [PromotionsComponent],
})
export class PromotionsModule {}
